export default __webpack_public_path__ + "media/shopify.4687e41d.svg";